import { useGet } from './useApi';
import { EnrollmentBlocked } from '../shared-typings/models/enrollment-blocked.model';

/**
 * Hook to check if enrollment is blocked for the current user
 */
export const useGetIsEnrollmentBlocked = () => {
  return useGet<EnrollmentBlocked>('/v1/auth/reg/is-enrollment-blocked', {
    refetchInterval: false,
  });
};

// Keep the old export for backward compatibility
export const useRegInit = () => {
  return useGet<EnrollmentBlocked>('/v1/public/reg/is-enrollment-blocked', {
    refetchInterval: false,
  });
};
